import(/* webpackMode: "eager" */ "/vercel/path0/components/main/sidebars/post-sidebar.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/buttons/home.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/tabs.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/config/main/main-sidebar-config.ts")